import { Tooltip as AntTooltip } from "antd"
import { TooltipPlacement } from "antd/es/tooltip"

type Props = {
  children: React.ReactNode
  placement?: TooltipPlacement
  text: string
}

export const Tooltip: React.FC<Props> = ({ children, placement, text }) => (
  <AntTooltip placement={placement} title={text}>
    {children}
  </AntTooltip>
)
